import { EMPTY, from, Observable } from "rxjs"
import { switchMap, catchError } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import { Router } from "../../../server/router"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import {
    SIGN_IN_FAILURE,
    SIGN_IN_FORM_SUBMITTED,
    SIGN_IN_REQUESTED,
    SIGN_IN_SUCCESS,
    signInFailure,
    signInRequested,
    signInSuccess,
} from "./actions"
import { createLoadingEnded, createLoadingStarted } from "../../filters/actions"
import { cookieNames, setCookie } from "../../../utils/cookies"
import type { LoginResponsePayload } from "../../../api/login"
import { Action, StateObject } from "../../redux/types"

export const loginSubmitted = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(SIGN_IN_FORM_SUBMITTED),
        switchMap((action: Action) => {
            Router.push("/login")
            return [createLoadingStarted("login-form"), signInRequested(action.payload.email, action.payload.password)]
        })
    )

export const loginRequested = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(SIGN_IN_REQUESTED),
        switchMap((action: Action) =>
            deps.api.login({}, action.payload.email, action.payload.password).pipe(
                switchMap((response: LoginResponsePayload) => [
                    signInSuccess(response.session, response.role, response.user_id, action.payload.email),
                ]),
                catchError(error => {
                    let message: string
                    switch (error?.type) {
                        case "NoAccess":
                            message = "Access Denied. Please contact your account administrator for access."
                            break
                        default:
                            message = "The email and password you entered did not match our records."
                    }
                    return from([createLoadingEnded("login-form"), signInFailure(error, message, error?.type ?? null)])
                })
            )
        )
    )

export const loginSuccess = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(SIGN_IN_SUCCESS),
        switchMap((action: Action) => {
            setCookie(cookieNames.session, action.payload.session)
            setCookie(cookieNames.userRole, action.payload.role)
            setCookie(cookieNames.userId, action.payload.userId)
            setCookie(cookieNames.userEmail, action.payload.userEmail)

            return EMPTY
        })
    )

export const loginFailure = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(SIGN_IN_FAILURE),
        switchMap((action: Action) => {
            let error: string
            switch (action.payload.type) {
                case "NoAccess":
                    error = "no-access"
                    break
                default:
                    error = "invalid"
            }
            Router.push(`/login?error=${error}`)
            return EMPTY
        })
    )
export default [loginSubmitted, loginRequested, loginSuccess, loginFailure]
